import { PaidDomainsApiClient } from '@fourthwall/services/dist/PaidDomainsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGetSuggestionsQuery = createQueryHook(PaidDomainsApiClient.getSuggestions, {
  queryKey: ['getSuggestions'],
})
